import * as go from 'gojs';
import { getImageMobileJawAndCone } from 'unitData/Mobile/JawAndCone/getImageMobileJawAndCone';
import { alignPorts } from 'unitData/Mobile/JawAndCone/jawAndConeData';
import {
  getImageBinding,
  getMobileInputPort,
  getMobileOutputPort,
  makeNode,
  mobileUnitDefaultOptions,
} from '../../utils';

const MobileJawAndConeTemplate = makeNode(
  getImageBinding('', () => getImageMobileJawAndCone()),
  [
    getMobileOutputPort(0, alignPorts),
    getMobileOutputPort(1, alignPorts),
    getMobileOutputPort(2, alignPorts),
    getMobileOutputPort(3, alignPorts),
    getMobileOutputPort(4, alignPorts),
    getMobileInputPort((node) => {
      return node.mirrored
        ? new go.Spot(1 - 4 / 12, 0)
        : new go.Spot(4 / 12, 0);
    }),
  ],
  { ...mobileUnitDefaultOptions },
);

export default MobileJawAndConeTemplate;
